import React from 'react';
import Icon from '@ant-design/icons';
import { ColumnTitle } from '../ColumnTitle';
import { ReactComponent as FilterFunnelSVG } from '../../assets/icons/FilterFunnelIcon.svg';
import { ReactComponent as CopyIconSVG } from '../../assets/icons/Copy.svg';
import { parseType } from '../../utils/parseType';
import { Dropdown, Button, Image, Space, Checkbox, Typography } from 'antd';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { getSPQLSelectedColumns } from '../../redux/selectors/deep_scan';
import { infoNotification, showNotification } from '../Notifications';
import { SPQLPivotingActions } from '.';

const FilterFunnelIcon = ({ filtered, ...props }) => {
  const iconStyle = {
    width: 24,
    height: 24,
  };
  return (
    <Icon
      {...props}
      component={() => (
        <FilterFunnelSVG
          style={iconStyle}
          fill={filtered ? '#2B7FEE' : 'white'}
        />
      )}
    />
  );
};

const SPTypography = styled.div`
  .ant-table-thead {
    height: 48px;
  }
`;

export function useSPQLColumns({
  setRowExpanded,
  rowExpanded,
  selectedRows,
  setSelectedRows,
}) {
  const CopyIcon = (props) => (
    <Icon {...props} component={() => <CopyIconSVG fill="white" />} />
  );
  const selectedColumns = useSelector(getSPQLSelectedColumns);
  const defaultSPQLColumns = selectedColumns.map((field) => ({
    title: <ColumnTitle columnName={field} />,
    align: 'left',
    dataIndex: field,
    key: field,
    width: 200,
    render: (text, record, index) => {
      let value = text;
      if (!record[field]) {
        value = '';
      } else if (Array.isArray(record[field])) {
        value = '[' + record[field].join(', ') + ']';
      }

      const handleCopy = () => {
        navigator.clipboard.writeText(value);
        showNotification(
          infoNotification({
            statusCode: 100,
            message: 'Copied to clipboard',
          }),
        );
      };
      if (field === 'favicon_icons') {
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {field in record &&
              record[field].map((url, idx) => {
                return (
                  <Image
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                    width={23}
                    src={url}
                    key={idx}
                  />
                );
              })}
          </div>
        );
      }
      const iocType = parseType(value);
      if (typeof value === 'boolean') {
        value = value.toString();
      }
      const isIOCTypeValidForExplore =
        iocType === 'ipv4' || iocType === 'domain';
      return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {!!value && (
            <Button
              onClick={() => handleCopy()}
              style={{ border: 0, marginRight: 4, color: 'white' }}
              ghost
              icon={<CopyIcon style={{ fontSize: 16 }} />}
            />
          )}
          {isIOCTypeValidForExplore && (
            <Dropdown
              overlay={
                <SPQLPivotingActions
                  iocType={iocType}
                  field={record.key}
                  value={value}
                />
              }
              trigger={['click']}
            >
              <Button
                type="link"
                style={{
                  textWrap: 'wrap',
                  whiteSpace: "normal",
                  height: 'fit-content',
                  width: '100%',
                  padding: 0,
                  border: 0,
                  textAlign: 'left',
                }}
              >
                {value}
              </Button>
            </Dropdown>
          )}
          {!isIOCTypeValidForExplore && <span>{value}</span>}
        </div>
      );
    },
  }));
  return [
    {
      title: '',
      align: 'left',
      fixed: 'left',
      width: 46,
      render: (text, record, index) => {
        const isChecked = selectedRows?.includes(record.key);
        return (
          <Space>
            <Checkbox
              checked={isChecked}
              onChange={() => {
                setSelectedRows((prev) => {
                  if (isChecked) {
                    return prev.filter((key) => key !== record.key);
                  }
                  console.log(record);
                  return [...prev, record.key];
                });
              }}
            />
          </Space>
        );
      },
    },
    ...defaultSPQLColumns,
  ];
}
